import React from "react";
import { FormProvider } from "react-hook-form";
import { Paper } from "@mui/material";

import { FluxForm } from "@modules/flux/components/FluxForm";
import { useFluxCreateForm } from "./controller";

export const FluxPage = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending } = useFluxCreateForm();

  return (
    <Paper style={{ padding: "16px" }}>
      <FormProvider {...methods}>
        <FluxForm
          onSubmit={handleSubmit((data: any) => mutateAsync(data))}
          isSubmitting={isPending}
        />
      </FormProvider>
    </Paper>
  );
});
